import axios from 'axios'

const API_URL = 'https://racceair.herokuapp.com'
const API_LOCAL= 'http://localhost:8080'

// Create new goal

// Get user goals
const getDevices = async () => {

  const response = await axios.get(  API_URL+'/api/getDevices')
  return response.data
}

const createDevices = async (device) => {
  const response = await axios.post('https://racceair.herokuapp.com/api/createDevices',device)
  return response.data
}

const editDevices = async (data) => {


 const response = await axios.post('https://racceair.herokuapp.com/api/editDevices', data)
 if (response.data) {
   //localStorage.setItem('user', JSON.stringify(response.data))
   return response.data

 }


}



const getMapDevices = async (devices) => {


  /*
  const response = await axios.post('http://localhost:8000/getMapDevices', devices)
  console.log(response)
  return response.data
  */
}


const deviceService = {

  getDevices,
  createDevices,
  getMapDevices,
  editDevices
}

export default deviceService
